export default {
  "auth-wide": () => import("/opt/buildhome/repo/layouts/auth-wide.vue"),
  auth: () => import("/opt/buildhome/repo/layouts/auth.vue"),
  default: () => import("/opt/buildhome/repo/layouts/default.vue")
}